import React from 'react';
import PropTypes from 'prop-types';
import { ARTIFACT_TYPES } from '../../constants';
import ArtifactErrorBoundary from './ArtifactErrorBoundary';
import GridArtifact from './GridArtifact';
import TableArtifact from './TableArtifact';
import WidgetArtifact from './WidgetArtifact';
import MarkdownArtifact from './MarkdownArtifact';
import CodeArtifact from './CodeArtifact';
import UnsupportedArtifact from './UnsupportedArtifact';

const renderArtifact = artifact => {
    switch (artifact.type) {
        case ARTIFACT_TYPES.GRID:
            return <GridArtifact artifact={artifact} />;

        case ARTIFACT_TYPES.TABLE:
            return <TableArtifact artifact={artifact} />;

        case ARTIFACT_TYPES.WIDGET:
            return <WidgetArtifact artifact={artifact} />;

        case ARTIFACT_TYPES.MARKDOWN:
            return <MarkdownArtifact artifact={artifact} />;

        case ARTIFACT_TYPES.CODE:
            return <CodeArtifact artifact={artifact} />;

        case ARTIFACT_TYPES.ERROR:
            return <MarkdownArtifact artifact={artifact} />;

        default:
            return <UnsupportedArtifact artifact={artifact} />;
    }
};

const ArtifactRenderer = ({ artifact }) => (
    <ArtifactErrorBoundary>{renderArtifact(artifact)}</ArtifactErrorBoundary>
);

ArtifactRenderer.propTypes = {
    artifact: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        data: PropTypes.any,
        metadata: PropTypes.object,
    }).isRequired,
};

export default ArtifactRenderer;
